export default "__VITE_ASSET__BtPftdnj__"